import { AuthFlow, type AuthState } from 'types';

import type { KeycloakTokenResponse } from './config';

export const mapTokenResponseToAuthState = (tokens: KeycloakTokenResponse, apiKey: string): AuthState => {
  const accessToken = tokens.access_token ?? '';
  const jwtToken = accessToken.startsWith('Bearer ') ? accessToken : `Bearer ${accessToken}`;

  return {
    jwtToken,
    refreshToken: tokens.refresh_token ?? null,
    apiKey,
    tokenProvider: null,
    idToken: tokens.id_token ?? null,
    authFlow: AuthFlow.Supplier,
  };
};
